Apt.fn.extend('property', {}, {
	/**
	 * Initialize the media application
	 */
	initMedia() {
		const scope = this;

		scope.media = $.app.make('media', {
			view: 'property._media',
			target: '$media',
			model: $.context('media')
		});

		scope.initImages();
		scope.initEnlarge();

		scope.bindTabs();

		scope.initStreet();
	},

	/**
	 * Bind tab events
	 */
	bindTabs() {
		const scope = this;

		scope.tabs = Apt.fn.tab()
			.init('$propertyTabs', (id, init) => {
				if (! init) {
					scope.openTab(id);
				}
			});
	},

	/**
	 * Set active tab
	 *
	 * @param {String} target
	 */
	openTab(target) {
		const scope = this;

		LS.util.scrollTarget()
			.scrollTop(0);

		if (target === $.app.media.$get('activePanel')) {
			return;
		}

		$.app.media.$set('activePanel', target);

		if (scope.images) {
			target === 'images' ?
				scope.images.resume() :
				scope.images.pause();
		}

		if (scope.videoGallery) {
			if (target === 'videos') {
				scope.videoGallery.resume();
			} else {
				scope.videoGallery.pause();

				scope.videos.forEach(video => {
					video.pause();
				});
			}
		} else if (target === 'videos') {
			scope.initVideos(true);
		}

		if (target === 'map') {
			scope.showMap();
		} else if (
			target === 'acres' ||
			target === 'mapright' ||
			target === 'matterport'
		) {
			scope.initEmbed(target);
		}

		LS.analytics.interact('listing', 'tab', target);

		document.activeElement.blur();
	},

	/**
	 * Initialize fullscreen behavior
	 */
	initEnlarge() {
		const scope = this;

		$.events.on('$resize', 'mousedown', () => {
			scope.enlargeMedia();
		}, {
			namespace: 'property',
			delegate: '$media'
		});

		$$('images').on('click', e => {
			if (
				e.target.nodeName === 'IMG' &&
				$.screen.size() > 3 &&
				! $.app.media.$get('enlarged')
			) {
				scope.enlargeMedia();
			}
		}, {
			namespace: 'property'
		});
	},

	/**
	 * Enlarge media gallery
	 */
	enlargeMedia() {
		const scope = this;
		const enlarge = ! $.app.media.$get('enlarged', false);
		const fn = e => {
			if (e.keyCode === 27) { // Escape
				scope.enlargeMedia();
			}
		};

		if (enlarge) {
			$(document).on('keydown', fn, {
				namespace: 'property'
			});

			if (Apt.panel.opened()) {
				Apt.panel.locked = true;
			}

			LS.util.crop();

			LS.analytics.interact('listing', 'enlarge');
		} else {
			$(document).off('keydown', fn);

			if (Apt.panel.opened()) {
				setTimeout(() => {
					Apt.panel.locked = false;
				});
			}

			LS.util.uncrop();
		}

		$.app.media.$set('enlarged', enlarge);

		if (scope.map) {
			scope.map.resize();
		}
	},

	/**
	 * Initialize video players
	 *
	 * @param {Boolean} [autoplay=false]
	 */
	initVideos(autoplay) {
		const scope = this;

		LS.util.load('video', () => {
			if (! scope.id) {
				return;
			}

			scope.videos = $$('video').map((el, index) => Apt.fn.video()
				.init(el, autoplay && ! index, data => {
					LS.analytics.track({
						action: 'watch',
						target: 'listing',
						id: scope.id,
						category: 'play',
						attributes: {
							id: data.id
						}
					}, {
						key: scope.context.key,
						source: scope.context.source
					});
				})
			);

			scope.videoGallery = Apt.fn.gallery()
				.init({
					app: $.app.media,
					id: scope.id,
					bind: true,
					delegate: '$videos',
					large: true,
					type: 'video',
					move: () => {
						scope.videos.forEach(video => {
							video.pause();
						});
					}
				});
		}, true, false);
	},

	/**
	 * Initialize street view
	 */
	initStreet() {
		const scope = this;
		const center = scope.context.center;
		const street = scope.context.street;

		let options = '';

		if (street) {
			const [pano, heading] = scope.context.street.split('|');

			if (pano) {
				options += `&pano=${pano}`;
			}

			if (heading) {
				options += `&heading=${heading}`;
			}
		}

		$('#streetTab').on('mousedown', () => {
			const $iframe = $(`<iframe src="https://www.google.com/maps/embed/v1/streetview?location=${center[1]},${center[0]}&fov=100&key=${$.get('global.googleKey')}${options}" allowfullscreen></iframe>`);

			$$('streetMedia').append($iframe);
		}, {
			namespace: 'property',
			once: true
		});
	}
});